// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2enrz","type":"styles_type__C_G51","choices":"styles_choices__1Wde1"};